import { render, staticRenderFns } from "./NavDrawer.vue?vue&type=template&id=28db610c"
import script from "./NavDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NavDrawer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports